// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SearchBar__searchBar___2_nFx{display:flex;align-items:center;justify-content:center;border:1px solid #ccc;border-radius:100px;padding:4px 12px;margin-right:12px;cursor:pointer;transition:0.15s ease-out}.SearchBar__searchBar___2_nFx:hover{box-shadow:0 5px 10px rgba(0,0,0,0.2);transform:translateY(-2px)}.SearchBar__searchBarIcon___1dRoT{position:relative}.SearchBar__searchBarText___cbd0d{font-size:14px;opacity:0.7;margin-right:6px}\n", ""]);
// Exports
exports.locals = {
	"searchBar": "SearchBar__searchBar___2_nFx",
	"searchBarIcon": "SearchBar__searchBarIcon___1dRoT",
	"searchBarText": "SearchBar__searchBarText___cbd0d"
};
module.exports = exports;
